module.exports = __webpack_public_path__ + "static/ss20.8a2b214a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/studysmart/ss/ss20.jpg
// module id = 1198
// module chunks = 81679748166845